import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import { updateCategory } from "../store/action";


function CategoriesEdit({ item }) {
    const categories = useSelector((state) => state.categoryReducer.categories)
    const dispatch = useDispatch()
    const [editForm, setEditForm] = useState(
        {
            name: item.name
        }
    )

    const handleChange = (e) => {
        const { value, name } = e.target
        const input = {
            ...editForm,
            [name]: value
        }
        setEditForm(input)
    }



    const cancelEditHandler = () => {
        setEditForm(
            {
                name: item.name
            }
        )
    }

    const updateCategoryHandler = (e) => {
        console.log(editForm, "<<<form update")
        dispatch(updateCategory(e.target.value, editForm))
    }

    return (
        <section>
            <button className="btn btn-primary px-3 m-2" value={item.id} data-toggle="modal" data-target={`#updateModal${item.id}`}>Edit</button>

            <div className="modal fade" id={`updateModal${item.id}`} tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Update Category</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row mb-3">
                                <div className="col-3">
                                    <label>Name</label>
                                </div>
                                <div className="col">
                                    <input type="text" onChange={handleChange} className="form-control" name="name" value={editForm.name} />
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={cancelEditHandler}>Cancel</button>
                                <button type="button" className="btn btn-primary" onClick={updateCategoryHandler} value={item.id}>Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CategoriesEdit